<h2 mat-dialog-title class="icd__title">
  {{ "Bild zuschneiden" | translate:"paragraph-crop-image" }}
</h2>

<div mat-dialog-content>
  <image-cropper
		class="image-cropper"
		[imageBase64]="data.imageBase64"
		[maintainAspectRatio]="false"
		[format]="data.format"
		[output]="'base64'"
		[autoCrop]="true"
		[containWithinAspectRatio]="true"
		[allowMoveImage]="false"
		[onlyScaleDown]="true"
		[alignImage]="'center'"
		(imageCropped)="onCropped($event)"/>
</div>

<div mat-dialog-actions class="icd__actions icd__actions--end">
  <button class="icd__btn icd__btn--cancel" mat-button (click)="onCancel()">
    {{ "Abbrechen" | translate:"action-abort" }}
  </button>

  <button
    class="button--tertiary"
    mat-button
    (click)="onConfirm()"
    [disabled]="!cropped()"
  >
    {{ "Bestätigen" | translate:"action-confirm" }}
  </button>
</div>
